import { useState } from "react";
import { Copy, Check } from "@phosphor-icons/react";

/**
 * CopyChip — Vague 6.
 *
 * Wraps a value (phone/email/whatever) with a compact copy-to-clipboard
 * button. Shows a check mark for 1.2s on success.
 */
export function CopyChip({ value, testid, className = "", children }) {
  const [copied, setCopied] = useState(false);
  const onCopy = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!value) return;
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch (_) {
      // silent-fail — clipboard access might be blocked
    }
  };
  return (
    <button
      type="button"
      onClick={onCopy}
      data-testid={testid}
      className={`inline-flex items-center gap-0.5 text-[10px] text-muted-foreground hover:text-primary transition-colors ${className}`}
      title="Copier"
      aria-label={`Copier ${value}`}
    >
      {children}
      {copied ? (
        <Check size={10} weight="bold" className="text-primary"/>
      ) : (
        <Copy size={10} weight="regular"/>
      )}
    </button>
  );
}
